/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/* eslint-disable no-restricted-syntax */

import './AndroidAppBanner.scss';

import * as React from 'react';

import { CookieStorage, isAndroid, Icon } from 'sarsaparilla';
import appIconSrc from './app_icon.png';

export function AndroidAppBanner() {
    const cookieRef = React.useRef(new CookieStorage());

    const [isDismissed, setDismissed] = React.useState(() => {
        return Boolean(cookieRef.current.readCookie('android-smartbanner-closed'));
    });
    const [isInstalled, setInstalled] = React.useState(() => {
        return Boolean(cookieRef.current.readCookie('android-smartbanner-installed'));
    });

    const close = () => {
        cookieRef.current.createCookie('android-smartbanner-closed', 'true', 15);
        setDismissed(true);
    };

    const install = () => {
        cookieRef.current.createCookie('android-smartbanner-installed', 'true', 30);
        setInstalled(true);
    };

    if (!isAndroid() || isDismissed || isInstalled) {
        return null;
    }

    return (
        <section className="r1s--android-app-banner" aria-label="Android App Banner">
            <div className="dismiss">
                <button
                    className="close-button"
                    type="button"
                    onClick={close}
                    aria-label="Dismiss Android App promo"
                >
                    <Icon iconName="close" className="close-icon" />
                </button>
            </div>

            <div className="banner">
                <img
                    src={appIconSrc}
                    alt="App Icon"
                    width={32}
                    height={32}
                    className="app-icon"
                />

                <div>
                    <div className="title">Recreation.gov</div>
                    <div className="sub">View In Google Play Store</div>
                </div>
            </div>

            <div className="open">
                <a
                    href="https://play.google.com/store/apps/details?id=com.bah.r1smobile"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={install}
                    className="open-link"
                >
                    Open
                </a>
            </div>
        </section>
    );
}

// cSpell:ignore smartbanner
